import { ensureUnit } from '../ensure-unit';
import type { BoxControlValue } from './types';

/**
 * Convert BoxControl value to CSS padding properties
 *
 * @param {BoxControlValue | object} paddingValue - Padding value from BoxControl
 * @returns {object} CSS padding properties
 */
export function convertPaddingToCSS(
	paddingValue: BoxControlValue | object,
): object {
	if ( ! paddingValue || typeof paddingValue !== 'object' ) {
		return {};
	}

	const padding = paddingValue as BoxControlValue;
	const cssProps: { [ key: string ]: string } = {};

	if ( padding.top ) {
		cssProps.paddingTop = ensureUnit( padding.top );
	}

	if ( padding.right ) {
		cssProps.paddingRight = ensureUnit( padding.right );
	}

	if ( padding.bottom ) {
		cssProps.paddingBottom = ensureUnit( padding.bottom );
	}

	if ( padding.left ) {
		cssProps.paddingLeft = ensureUnit( padding.left );
	}

	return cssProps;
}
